/**
 * MSW Overrides: List Bookings — Quota with Before Booking scenario
 *
 * Forces listBookings to return a response whose each booking inside `content`
 * has its `quota` extended with `availableBefore` and `availableAfter` number fields,
 * so the extended-quota rendering can be tested end-to-end in local development.
 *
 * Enable by setting ENABLE_MSW=true and MSW_OVERRIDE=true in your .env,
 * then restart the dev server.
 */

import { http, HttpResponse } from 'msw';
import { BFF_ENDPOINTS, createMockBookingsListResponse, toMSWPattern } from '@cvo/domain';
import type { BookingListQuota } from '@cvo/domain';
import type { PathParams } from 'msw';

const MOCK_BOOKING_QUOTA: BookingListQuota = {
  consumed: 3,
  availableBefore: 10,
  availableAfter: 7,
};

export function createListBookingsQuotaBeforeBookingOverrides(baseUrl: string) {
  const sanitizedBaseUrl = baseUrl.replace(/\/$/, '');

  return [
    http.get(
      `${sanitizedBaseUrl}/${toMSWPattern(BFF_ENDPOINTS.BOOKING_LIST)}`,
      ({ request }: { request: Request; params: PathParams }) => {
        const url = new URL(request.url);
        const page = Number(url.searchParams.get('page')) || 1;

        const response = createMockBookingsListResponse({ page });

        const sanitized = {
          ...response,
          content: response.content.map(booking => ({
            ...booking,
            quota: { ...booking.quota, ...MOCK_BOOKING_QUOTA },
          })),
        };

        return HttpResponse.json(sanitized);
      },
    ),
  ];
}
